import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { I18N_SERP_NS } from './constants';
export const useI18n = () => {
    const { language } = useLocale();
    const { addTranslations } = useTranslation(I18N_SERP_NS);
    // eslint-disable-next-line import/no-dynamic-require, global-require, @typescript-eslint/no-var-requires
    const serpTranslations = require(`../../locales/${language}/serp.json`);
    // Loading new translations in the event of a change of locale
    addTranslations({
        language,
        translations: serpTranslations,
    });
};
export * from './useSerpTranslation';
export * from './constants';
